import React from 'react';
import EnterQrCode from './components/EnterQrCode';
import { Scanner } from '@yudiel/react-qr-scanner';
import TicketSuccessStatus from './components/TicketSuccessStatus';
import TicketErrorStatus from './components/TicketErrorStatus';

import useCheck from './useCheck';
import './styles.sass';
import classNames from 'classnames';

const Tickets = () => {
    const {
        loading,
        success,
        successData,
        errorData,
        resetState,
        handleScan,
        check,
        isPhoneOrTablet,
        isInputFocus,
        setIsInputFocus,
    } = useCheck();

    return (
        <div className="check-wrap">
            {success && successData && <TicketSuccessStatus successData={successData} onClose={resetState} />}
            {errorData && <TicketErrorStatus errorData={errorData} onClose={resetState} />}

            {isPhoneOrTablet && (
                <div className={classNames('qr-reader', isInputFocus && 'qr-reader--hide-area')}>
                    <Scanner
                        classNames={{ container: 'qr-reader__scanner' }}
                        onError={() => {}}
                        sound={false}
                        scanDelay={100}
                        onScan={handleScan}
                    />
                </div>
            )}
            {success && successData?.type === 'new' ? null : (
                <div className="qr-field">
                    <EnterQrCode
                        loading={loading}
                        onSubmit={check}
                        onBlur={() => {
                            setIsInputFocus(false);
                        }}
                        onFocus={() => {
                            setIsInputFocus(true);
                        }}
                    />
                </div>
            )}
        </div>
    );
};

export default Tickets;
